import { API_TYPE, OPERATION_METHOD } from '~/portal/types/content'

export const buildAsyncApiOperationHash = ({ operationId, method, path }: {operationId?: string, method?: OPERATION_METHOD, path?: string}) => {
  if (operationId) {
    const operationPrefix = method === OPERATION_METHOD.SUB ? 'operation-send' : 'operation-receive'
    return `${operationPrefix}-${operationId}`
  }
  return path
}

export const buildOperationHash = ({
  operationId,
  tag,
  method,
  path,
}: {
  operationId?: string,
  tag?: string,
  method?: OPERATION_METHOD,
  path?: string,
}) => {
  const encodedTag = tag ? encodeURIComponent(tag) : 'default'
  const encodedOperationId = operationId
    ? encodeURIComponent(operationId)
    : (method?.toLowerCase() || '') + (path || '').replaceAll(/[\/{}.:]/g, '_')

  const encodedMethod = method && [OPERATION_METHOD.SUB, OPERATION_METHOD.PUB].includes(method)
    ? buildAsyncApiOperationHash({ operationId, method, path })
    : encodedOperationId
  return [
    '#',
    encodedTag,
    encodedMethod,
  ].filter(Boolean).join('/')
}

export const getApiTypeFromSpec = (spec?: string) => {
  if (spec?.includes('openapi')) {
    return API_TYPE.OPENAPI
  }
  if (spec?.includes('asyncapi')) {
    return API_TYPE.ASYNCAPI
  }
  if (spec?.includes('graphql')) {
    return API_TYPE.GRAPHQL
  }
  if (spec?.includes('a2a-1.0.1')) {
    return API_TYPE.A2A
  }
  if (spec?.includes('mcp')) {
    return API_TYPE.MCP
  }
  if (spec?.includes('grpc')) {
    return API_TYPE.GRPC
  }
  return API_TYPE.INVALID
}

export const isMcp = (spec?: string) => getApiTypeFromSpec(spec) === API_TYPE.MCP

export const isA2A = (spec?: string) => getApiTypeFromSpec(spec) === API_TYPE.A2A

export const isAIDefinition = (spec?: string) => isMcp(spec) || isA2A(spec)